(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MoveoAI", [], factory);
	else if(typeof exports === 'object')
		exports["MoveoAI"] = factory();
	else
		root["MoveoAI"] = factory();
})(this, function() {
return 